/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_ACCOUNT_OPTIONS_LIST = 'SET_ACCOUNT_OPTIONS_LIST';
export const SET_ACCOUNT_SELECTED_OPTION = 'SET_ACCOUNT_SELECTED_OPTION';
